import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import DarkMode from '@modules/dark-mode';
import { localeToPrimeVueDateFormat } from '@modules/locale-to-primevue-date-format';

export default {
    locale: {
        dateFormat: localeToPrimeVueDateFormat(navigator.language.toLocaleLowerCase())
    },
    pt: {
        directives: {
            tooltip: {
                // Disable tooltips for touch devices (https://github.com/primefaces/primevue/issues/3576)
                root: 'hidden! md:inline-block!'
            }
        },
        message: {
            content: 'h-auto! [&>svg:first-child]:shrink-0!'
        },
        scrollPanel: {
            barX: 'bg-primary/50!',
            barY: 'bg-primary/50!'
        }
    },
    ripple: true,
    theme: {
        options: {
            darkModeSelector: '.' + DarkMode.CSS_CLASS
        },
        preset: definePreset(Aura, {
            semantic: {
                colorScheme: {
                    light: {
                        surface: {
                            0: '#ffffff',
                            50: '{gray.50}',
                            100: '{gray.100}',
                            200: '{gray.200}',
                            300: '{gray.300}',
                            400: '{gray.400}',
                            500: '{gray.500}',
                            600: '{gray.600}',
                            700: '{gray.700}',
                            800: '{gray.800}',
                            900: '{gray.900}',
                            950: '{gray.950}'
                        }
                    }
                },
                primary: {
                    50: 'var(--color-primary-1-50,var(--legacy-color-primary-1-50))',
                    100: 'var(--color-primary-1-100,var(--legacy-color-primary-1-100))',
                    200: 'var(--color-primary-1-200,var(--legacy-color-primary-1-200))',
                    300: 'var(--color-primary-1-300,var(--legacy-color-primary-1-300))',
                    400: 'var(--color-primary-1-400,var(--legacy-color-primary-1-400))',
                    500: 'var(--color-primary-1-500,var(--legacy-color-primary-1-500))',
                    600: 'var(--color-primary-1-600,var(--legacy-color-primary-1-600))',
                    700: 'var(--color-primary-1-700,var(--legacy-color-primary-1-700))',
                    800: 'var(--color-primary-1-800,var(--legacy-color-primary-1-800))',
                    900: 'var(--color-primary-1-900,var(--legacy-color-primary-1-900))',
                    950: 'var(--color-primary-1-950,var(--legacy-color-primary-1-950))'
                }
            }
        })
    }
};
